import bus from "../BusEmisor";
import app from "../../main";

class errorManager {

	error;
	typeError;

	constructor(error, typeError = null) {
		this.error = error;
		this.typeError = typeError;
	}

	apiError(show_generic_error = false, show_details_error = false) {

		if (show_generic_error)
			bus.$emit("page_loader_error", true);

		if (show_details_error)
			bus.$emit("page_loader_error", this.error);

	}

	static showToast(message) {
		app.$toast.error(message, {
			dismissible: true,
			duration: 6000,
			position: 'bottom'
		});
	}
}

export default errorManager;



// WEBPACK FOOTER //
// ./src/js/connection/errorManager.js